import { useCallback, useEffect, useState } from "react";
import { ConfirmProps } from "./interfaces";

export const useConfirmHooks = (props: ConfirmProps) => {
  const [busy, setBusy] = useState(false);

  const onOkClick = useCallback(() => {
    // OKボタンクリック時
    setBusy(true);
  }, []);

  useEffect(() => {
    if (busy) {
      props.onOkClick({} as React.MouseEvent<HTMLButtonElement, MouseEvent>);
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setBusy(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [busy]);

  return { busy, onOkClick } as const;
};
